document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("ContactLeaderboard");
    const nameInput = document.getElementById("ContactLeaderboard-name");
    const emailInput = document.getElementById("ContactLeaderboard-email");
    const phoneInput = document.getElementById("ContactLeaderboard-phone");
    const languageSelect = document.getElementById("ContactLeaderboard-language");
    const customVoteInput = document.getElementById("ContactLeaderboard-custom-vote-wrapper");
    const tagsInput = document.getElementById("ContactLeaderboard-tags");

    const currentUrl = window.location.href;
    if (currentUrl.includes("customer_posted=true")) {
        if (currentUrl.includes("language-leaderboard")) {
            return;
        } else {
            // Redirect to the leaderboard page if customer_posted=true is present
            window.location.href = "/pages/language-leaderboard?customer_posted=true";
            return;
        }
    }

    if (!form || !nameInput || !emailInput || !phoneInput || !languageSelect || !customVoteInput || !tagsInput) {
        console.error("Required form elements are missing.");
        if (!form) {
            console.error("Form element not found");
        }
        if (!nameInput) {
            console.error("Name input not found");
        }
        if (!emailInput) {
            console.error("Email input not found");
        }
        if (!phoneInput) {
            console.error("Phone input not found");
        }
        if (!languageSelect) {
            console.error("Language select input not found");
        }
        if (!customVoteInput) {
            console.error("Custom vote input not found");
        }
        if (!tagsInput) {
            console.error("Tags input not found");
        }
        return;
    }

    // Hide custom vote field by default
    customVoteInput.style.display = "none";

    // Toggle custom vote input
    languageSelect.addEventListener("change", () => {
        console.log('changed languageSelect:', languageSelect.value);
        const isCustom = languageSelect.value === "new-vote";
        customVoteInput.style.display = isCustom ? "block" : "none";
    });

    form.addEventListener("submit", (event) => {
        // event.preventDefault(); ///delete this later
        // Get values
        const email = emailInput.value.trim();
        const isCustom = languageSelect.value === "new-vote";
        const languageName = isCustom ? customVoteInput.value.trim() : languageSelect.value;

        // Validate
        if (!languageName) {
            console.error("Please select a language or enter a custom vote.");
            return;
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            console.error("Please enter a valid email.");
            return;
        }

        // Set tags
        const languageTag = languageName.toLowerCase().replace(/\s+/g, "_");
        const tags = ["leaderboard"];
        if (isCustom) {
            tags.push("new-vote", languageTag);
        } else {
            tags.push(languageTag);
        }
        tagsInput.value = tags.join(",");

        // Send vote to AWS before unload (if not custom)
        if (!isCustom) {
            const votePayload = JSON.stringify({ name: languageName, email });
            const blob = new Blob([votePayload], { type: "application/json" });
            const beaconSuccess = navigator.sendBeacon("https://umc4cctp9g.execute-api.us-east-2.amazonaws.com/default/makeVote", blob);
            console.log("Vote beacon sent:", beaconSuccess);
        }

        // Wait for Shopify form submission to complete
        form.addEventListener("ajax:success", () => {
            console.log("Shopify form submitted successfully.");
            window.location.href = "/pages/language-leaderboard?customer_posted=true";
        });

        form.addEventListener("ajax:error", () => {
            console.error("Shopify form submission failed.");
        });

    });
});